import { ReactNode } from 'react';
import { Stack } from 'components';
import { ClientProfileContentItem } from 'store/clientProfile/clientProfileSlice';

import { NoteFormProvider } from '../context/noteFormContext';

type RootProps = {
  children: ReactNode;
  clientId: string;
  note?: ClientProfileContentItem;
  disabled?: boolean;
};

export const Root = ({ children, clientId, note, disabled = false }: RootProps) => {
  return (
    <NoteFormProvider clientId={clientId} note={note} disabled={disabled}>
      <Stack width="100%" mt="16px" display="flex" gap="28px" data-test-id="profile-notes-form">
        {children}
      </Stack>
    </NoteFormProvider>
  );
};
